// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
const packageJson = require('../package.json');
export const LIB_VERSION = packageJson.version;
